module.exports = __webpack_public_path__ + "img/logo.af0a3085.png";